<div class="wrap">


  <div class="header">
    <div class="title">
      <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active"
        appChangeColorTheme attribute="color"></fa-icon>
      <h2>{{title}}</h2>
    </div>

    <div class="add_search_federation">
      <div class="add_federation" (click)="openDialogAddFederation('add')" appChangeColorTheme [isHover]="true">
          <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
          <span>Ajouter une fédération</span>
      </div>
      <div class="search_bar">
          <form [formGroup]="searchForm">
              <input type="text" placeholder="Chercher une fédération ..." (input)="applyFilter($event.target.value)"
                  formControlName="keyword">

          </form>

          <fa-icon [icon]="getFaIcon('faTimes')" (click)="resetSearch()" class="faTimes" *ngIf="valueInput" ></fa-icon>
          <fa-icon [icon]="getFaIcon('faSearch')" *ngIf="!valueInput" ></fa-icon>

      </div>
  </div>

  </div>

  <section [hidden]="federations.length === 0 || isLoading" class="content">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">

      <ng-container matColumnDef="label">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Label</th>
        <td mat-cell *matCellDef="let federation">
          <fa-icon [icon]="getFaIcon('faChevronDown')" matTooltip="Ouvrir les licences" appChangeColorTheme attribute="color" class="expand-icon" *ngIf="federation !== this.expandedElement" (click)="expandRow(federation, $event)"></fa-icon>
          <fa-icon [icon]="getFaIcon('faChevronUp')" matTooltip="Fermer les licences" appChangeColorTheme attribute="color" class="expand-icon" *ngIf="federation === this.expandedElement" (click)="expandRow(federation, $event)"></fa-icon>
          {{ federation.label }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
        <td mat-cell *matCellDef="let federation">{{ federation.description}} </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
        <td mat-cell *matCellDef="let federation">
          <fa-icon [icon]="getFaIcon('faEdit')" matTooltip="Editer la fédération" appChangeColorTheme attribute="color" (click)="$event.stopPropagation();openDialogAddFederation('edit', federation)"></fa-icon>
        </td>
      </ng-container>


      <ng-container matColumnDef="expandedDetail">
        <td class="expandedrow" mat-cell *matCellDef="let federation" [attr.colspan]="displayedColumns.length">
          <div class="example-element-detail" [@detailExpand]="(federation.federationKey == idExpanded) ? 'expanded' : 'collapsed'">
            <div class="licencesTable">
              <app-admin-licences [licences]="federation.licences" [federation]="federation"></app-admin-licences>
            </div>
          </div>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
        [class.example-expanded-row]="expandedElement === element" (click)="expandRow(element, $event)">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>
    <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
      (page)="pageEvent = $event" [color]="color">
    </mat-paginator>
  </section>

  <mat-spinner *ngIf="isLoading" [diameter]="75"></mat-spinner>

  <ng-container *ngIf="federations.length === 0 && !isLoading">
    <p>Il n'y a pas de fédérations.</p>
  </ng-container>

</div>
